//globals
let axios, delayBetweenRequests;
/**
 *
 * @param {any} axiosArg axios object
 * @param {number} delayBetweenRequests delay between requests in miliseconds
 */
function init(axiosArg, delayBetweenRequestsArg) {
  axios = axiosArg;
  delayBetweenRequests = delayBetweenRequestsArg;
}

/**
 *
 * @param {time} time sleep time in miliseconds
 */
function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

/**
 *
 * @param {any} options axios options
 * @param {number} index index from urls array
 */
function getRequestPromise(options, index) {
  const _options = JSON.parse(JSON.stringify(options));
  return sleep(delayBetweenRequests * index).then(() => {
    return axios(_options);
  });
}

const axiosThrottle = {
  init,
  getRequestPromise
};

module.exports = axiosThrottle;



// WEBPACK FOOTER //
// ./src/index.js